import React from "react";
import "./styles.css";
import { ArrowRightIcon } from "../../../Assets/images/svgs";

const CSHeader = ({ onClick = () => {}, headerText = "" }) => {
  return (
    <div className="cs-header">
      <div className="cs-header-content-container">
        {headerText ? <>
          <ArrowRightIcon onClick={onClick} className="cs-header-arrow" />
          <p className="cs-header-text">{headerText}</p>
        </> : null}
      </div>
    </div>
  )
}

export default CSHeader
